import { render } from "./EditEventNotification.vue?vue&type=template&id=3607f83b"
import script from "./EditEventNotification.vue?vue&type=script&lang=js"
export * from "./EditEventNotification.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__